<template>
  <VView class="contest-error" :header="$t('contestError.header')">
    <VText center>{{ $t('contestError.content.0') }}</VText>
    <VText center small>{{ $t('contestError.content.1') }}</VText>

    <VBlock max-width="320px">
      <transition name="bounceUp" appear>
        <VButton to="/contest/legals">Powrót</VButton>
      </transition>
    </VBlock>
  </VView>
</template>

<script>
export default {
  name: 'ContestEnd',

  props: {
    backButtonTo: {
      type: String,
      default: '/menu',
    },
  },
};
</script>

<style lang="scss" scoped>
.contest-end {}
</style>
